/**
 * This is used to decouple the Med association component from the other forms, but allows a reliable means to refactor
 * and connect these two components
 */
const MED_ASSOCIATION_FIELD_NAME = 'medicationAssociations';

export { MED_ASSOCIATION_FIELD_NAME };
